document.addEventListener('DOMContentLoaded', function () {
 initRolexCPOMenu();
 initCPOBannerSlider();
 initCPOContentSliders();
 initializeProductGallery();
 initialize360Viewer();
 initRolexPreownedAccordion();
 initCPOSkipLinks();
 initCPORolexKeyboardFocus();
 initCPOGloboTabIndex();
 initCPOGuaranteeAccordion();
 initPreownedCollectionFilters();
 initFilterKeyboardSupport();
//  initConsentLinks();
});

function initRolexCPOMenu() {
  const toggleButton = document.querySelector('.cpo-menu-button');
  const mobileMenu = document.querySelector('.cpo-navigation-mobile-wrapper');
  const toggle_icon = document.querySelector('.cpo-menu-button');
  if (!toggleButton) return;
  if (!mobileMenu) return;
  if (!toggle_icon) return;

  toggleButton.addEventListener('click', function (e) {
    e.preventDefault();
    if (mobileMenu.hasAttribute('active')) {
      // Hide menu
      mobileMenu.removeAttribute('active');
      toggle_icon.removeAttribute('active');
    } else {
      // Show menu
      mobileMenu.setAttribute('active', '');
      toggle_icon.setAttribute('active', '');
    }
  });
}

function initCPOBannerSlider() {
  document.querySelectorAll('.rolex-preowned-banner-slider').forEach((slider) => {
    const showArrows = slider.dataset.showArrows === 'true';
    const showPagination = slider.dataset.showPagination === 'true';

    new Splide(slider, {
      type: 'slide',
      perPage: 1,
      arrows: showArrows,
      pagination: showPagination,
      autoplay: false,
      interval: 5000,
      pauseOnHover: true,
    }).mount();
  });
}

function initCPOContentSliders() {
  const sliders = [
        {
            selector: '#feature-product-slider',
            perPage: 4,
            linkSelector: '.splide__slide a'
        },
        {
            selector: '#related-products-slider',
            perPage: 3,
            linkSelector: '.splide__slide a'
        },
        {
            selector: '#keep-exploring-slider',
            perPage: 4,
            linkSelector: '.splide__slide a'
        },
    ];

    sliders.forEach((sliderConfig) => {
        const element = document.querySelector(sliderConfig.selector);
        if (!element) return;

        const totalSlides =
            element.querySelectorAll('.splide__slide').length;

        const splide = new Splide(sliderConfig.selector, {
            type: 'slide',
            perPage: sliderConfig.perPage,
            arrows: totalSlides > sliderConfig.perPage,
            pagination: totalSlides > sliderConfig.perPage,
            gap: '0px',
            drag: true,

            breakpoints: {
                1023: {
                    perPage: 3,
                    arrows: totalSlides > 3,
                    pagination: totalSlides > 3,
                },
                767: {
                    perPage: 2,
                    arrows: totalSlides > 2,
                    pagination: totalSlides > 2,
                },
            },
        });

        splide.mount();
        disableSplideArrowsFocus(sliderConfig.selector);
        disableSplidePaginationFocus(
            splide,
            sliderConfig.selector
        );
        attachSplideKeyboardRoving(
            splide,
            sliderConfig.selector,
            sliderConfig.linkSelector
        );
    });
}

function initRolexPreownedAccordion() {
  // scope only this section
  const accordions = document.querySelectorAll('.rolex-preowned_accordion .rolex-preowned_accordion-item');

  if (!accordions.length) return false;

  function updateHeight(content) {
    if (!content) return;
    requestAnimationFrame(() => {
      content.style.maxHeight = content.scrollHeight + 'px';
    });
  }

  accordions.forEach(function (item, index) {
    const header = item.querySelector('.accordion-header');
    const content = item.querySelector('.rolex-preowned_accordion-content');

    if (!header || !content) {
      console.warn('[Shopify Accordion] Missing header/content', item);
      return;
    }

    // accessibility
    header.setAttribute('aria-expanded', 'false');

    // Default open first
    if (index === 0) {
      item.classList.add('open');
      header.setAttribute('aria-expanded', 'true');
      updateHeight(content);
    } else {
      content.style.maxHeight = '0px';
    }

    function openAccordion() {
      item.classList.add('open');
      header.setAttribute('aria-expanded', 'true');
      updateHeight(content);
    }

    function closeAccordion() {
      item.classList.remove('open');
      header.setAttribute('aria-expanded', 'false');
      content.style.maxHeight = '0px';
    }

    // Toggle click
    header.addEventListener('click', function () {
      if (item.classList.contains('open')) {
        closeAccordion();
      } else {
        openAccordion();
      }
    });

    // MutationObserver (dynamic form / success / steps)
    const observer = new MutationObserver(function () {
      if (item.classList.contains('open')) {
        updateHeight(content);
      }
    });

    observer.observe(content, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'data-step'],
    });

    // Image load fix
    const imgs = content.querySelectorAll('img');
    imgs.forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', () => {
          if (item.classList.contains('open')) {
            updateHeight(content);
          }
        });
      }
    });
  });

  // Window load safety
  window.addEventListener('load', function () {
    accordions.forEach((item) => {
      if (item.classList.contains('open')) {
        const content = item.querySelector('.rolex-preowned_accordion-content');
        if (content) {
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      }
    });
  });

  return true;
}

function initializeProductGallery() {
  const openSliderButton = document.getElementById('openSliderButton');
  const sliderPopup = document.getElementById('sliderPopup');
  const closeSliderButton = document.getElementById('closeSliderButton');

  // Ensure required elements are present
  if (!sliderPopup || !closeSliderButton) {
    console.warn('Product gallery popup elements not found.');
    return;
  }

  initMainGallery();
  init360ImageSlider();
  bindPopupEvents(openSliderButton, sliderPopup, closeSliderButton);
}

function initMainGallery() {
  if (!document.querySelector('#rolex-preowned-gallery')) return;
  if (!document.querySelector('#rolex-preowned-gallery-thumbs')) return;

  const gallery = new Splide('#rolex-preowned-gallery', {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    pagination: true,
    arrows: true,
    autoplay: false,
  });

  const thumbs = new Splide('#rolex-preowned-gallery-thumbs', {
    perPage: 4,
    isNavigation: true,
    gap: 8,
    focus: 'center',
    pagination: false,
    arrows: false,
    speed: 50,
  });

  

  thumbs.on('mounted', function () {
    thumbs.Components.Elements.slides.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        gallery.go(index + 1);
        thumb.classList.add('is-active');
      });
    });
  });

  gallery.on('move', function (index) {
    const thumbIndex = index - 1;
    if (thumbIndex >= 0 && thumbIndex < thumbs.length) {
      thumbs.go(thumbIndex);
    } else {
      thumbs.Components.Elements.slides.forEach((slide) => {
        slide.classList.remove('is-active');
      });
    }
  });

  let run = 0;
  thumbs.on('active', function (index) {
    if (run <= 1) {
      thumbs.Components.Elements.slides.forEach((slide) => {
        slide.classList.remove('is-active');
      });
    }
    run++;
  });

  gallery.mount();
  thumbs.mount();
}

function init360ImageSlider() {
  const slider = document.querySelector('#rolex-preowned-gallery360');

  if (!slider) return;
  new Splide('#rolex-preowned-gallery360', {
    perPage: 1,
    perMove: 1,
    pagination: true,
    arrows: true,
    autoplay: false,
    drag: false,
  }).mount();
}

function bindPopupEvents(openButton, popup, closeButton) {
  if (!openButton || !popup || !closeButton) return;
  openButton.addEventListener('click', function () {
    popup.style.display = 'grid'; // Show the popup
  });

  closeButton.addEventListener('click', function () {
    popup.style.display = 'none'; // Hide the popup
  });
}

function initialize360Viewer() {
  const viewer = document.querySelector('.gallery360__viewer');
  if (!viewer) {
    console.warn('360 viewer element not found.');
    return;
  }

  const images = viewer.querySelectorAll('img');
  if (images.length === 0) {
    console.warn('No images found for 360 viewer.');
    return;
  }

  let frame = 0;
  const totalImages = images.length;
  const threshold = 45;

  // Activate the first image
  updateActiveImage(images, frame);

  // Impetus for left-right drag interaction
  new Impetus({
    source: viewer,
    multiplier: 1.5,
    friction: 0.85,
    boundY: [0, 0], // Prevent vertical movement
    update: (x) => {
      const newFrame = calculateFrame(x, threshold, totalImages);
      if (newFrame !== frame) {
        updateActiveImage(images, newFrame);
        frame = newFrame;
      }
    },
  });
}

function initCPOSkipLinks() {
  const links = document.querySelectorAll('.skip-links .skip-link');
  if (!links.length) return;

  links.forEach(function (link) {

    link.addEventListener('click', function (event) {
      event.preventDefault();

      const targetId = this.getAttribute('data-target');
      if (!targetId) return;

      const target = document.getElementById(targetId);
      if (!target) return;

      // --- Smooth scroll ---
      try {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      } catch (e) {
        // Fallback
        target.scrollIntoView(true);
      }

      // --- Move keyboard focus for accessibility ---
      setTimeout(function () {
        const hadTabindex = target.hasAttribute('tabindex');

        if (!hadTabindex) {
          // Make it temporarily focusable
          target.setAttribute('tabindex', '-1');
        }

        try {
          target.focus({ preventScroll: true });
        } catch (e) {
          // Older browsers
          target.focus();
        }

        // Clean up if we added tabindex
        if (!hadTabindex) {
          setTimeout(() => target.removeAttribute('tabindex'), 800);
        }

      }, 300);
    });

  });
}

document.addEventListener('click', function (event) {
  if (event.target.matches('.toggle-collection')) {
    const parent = event.target.closest('.view-collection');
    if (parent) {
      parent.classList.toggle('open');
      const isOpen = parent.classList.contains('open');
    }
  }
});




function updateActiveImage(images, frame) {
  images.forEach((image) => image.classList.remove('active'));
  images[frame].classList.add('active');
}

function calculateFrame(x, threshold, totalImages) {
  let frame = Math.floor(-x / threshold) % totalImages;
  return frame < 0 ? totalImages + frame : frame;
}

function initCPORolexKeyboardFocus() {
   /*  1) If .rolex-header is present inside #MainContent, add "has-rolex" */
   const mainContent = document.getElementById('MainContent');
    if (mainContent && mainContent.querySelector('.cpo-rolex-header')) {
      mainContent.classList.add('has-cpo-rolex');
    }

   /* 2) If #MainContent has class "has-rolex", enable keyboard-only behavior
          - Pressing TAB will add class "keyfocus" on #MainContent
          - Any mouse click will remove class "keyfocus" */
    if (!mainContent || !mainContent.classList.contains('has-cpo-rolex')) return;

    // Add keyfocus when user presses Tab (keyboard navigation)
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Tab') {
        mainContent.classList.add('keyfocus');
      }
    });

    // Remove keyfocus on mouse interaction
    document.addEventListener('mousedown', function () {
      mainContent.classList.remove('keyfocus');
    });
}

function initCPOGloboTabIndex() {
  function applyTabIndex() {
    const elements = document.querySelectorAll(
      '.globo-paragraph, .globo-heading, .heading-caption, .rpo-form_location > label.globo-label'
    );

    elements.forEach(function (el) {
      el.setAttribute('tabindex', '-1');
    });

    document.querySelectorAll(
      '.backtoblock > div, .preowned-form-holder .gfb__sticky-navigation-previous'
    ).forEach((el) => {
      el.setAttribute('tabindex', '0');
    });
  }
  applyTabIndex();

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function () {
      applyTabIndex();
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function initCPOGuaranteeAccordion() {
   const accordionItems = document.querySelectorAll(".guarantee-accordion .accordion-item");

    // Always open the first accordion by default
    if (accordionItems.length > 0) {
      const firstItem = accordionItems[0];
      const firstContent = firstItem.querySelector(".content");

      firstItem.classList.add("item-open");
      firstContent.style.maxHeight = firstContent.scrollHeight + "px";
    }

    // Setup toggle for each item
    accordionItems.forEach((item) => {
      const header = item.querySelector("h3");
      const content = item.querySelector(".content");

      header.addEventListener("click", () => {
        const isOpen = item.classList.contains("item-open");

        // Close all items
        accordionItems.forEach((i) => {
          i.classList.remove("item-open");
          i.querySelector(".content").style.maxHeight = null;
        });

        // If it was NOT open, then open it
        if (!isOpen) {
          item.classList.add("item-open");
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
    });
}

document.addEventListener('keydown', function (e) {
    const label = e.target.closest('.gfb__radio-label.globo-option');

    if (!label) return;

    if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        label.click();
    }
});

document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;

    const el = document.activeElement;

    if (el && el.getAttribute('tabindex') === '0') {
        e.preventDefault();
        el.click();
    }
});
// Arrows not focusable
function disableSplideArrowsFocus(selector) {
  const root = document.querySelector(selector);
  if (!root) return;

  const arrows = root.querySelectorAll('.splide__arrow');
  arrows.forEach((arrow) => {
    arrow.setAttribute('tabindex', '-1');
  });
}

// Dots not focusable
function disableSplidePaginationFocus(splideInstance, selector) {
  const root = document.querySelector(selector);
  if (!root) return;

  const setPaginationTabIndex = function () {
    const dots = root.querySelectorAll('.splide__pagination__page');
    dots.forEach((dot) => {
      dot.setAttribute('tabindex', '-1');
    });
  };

  setPaginationTabIndex();
  splideInstance.on('moved', setPaginationTabIndex);
}


// Roving tabindex across all slide links
function attachSplideKeyboardRoving(splideInstance, selector, linkSelector) {

    const root = document.querySelector(selector);
    if (!root) return;
    const links = Array.prototype.slice.call(
        root.querySelectorAll(linkSelector)
    );

    if (!links.length) return;

    links.forEach(link => {
        link.setAttribute('data-splide-no-drag', 'true');
    });

    function setActiveLink(index) {
        links.forEach(link => link.setAttribute('tabindex', '-1'));
        if (links[index]) {
            links[index].setAttribute('tabindex', '0');
        }
    }

    let initialIndex = 0;

    const activeSlideLink = root.querySelector(
        '.splide__slide.is-active ' + linkSelector
    );

    if (activeSlideLink) {
        const idx = links.indexOf(activeSlideLink);
        if (idx !== -1) {
            initialIndex = idx;
        }
    }

    setActiveLink(initialIndex);

    splideInstance.on('moved', function (newIndex) {
        setActiveLink(newIndex);
    });

    root.addEventListener('keydown', function (event) {

        if (event.key !== 'Tab') return;

        const current = document.activeElement;
        const currentIndex = links.indexOf(current);

        if (currentIndex === -1) return;
        if (event.shiftKey) {

            if (currentIndex === 0) {
                setActiveLink(0);
                return;
            }

            event.preventDefault();
            const prevIndex = currentIndex - 1;
            setActiveLink(prevIndex);
            splideInstance.go(prevIndex);
            links[prevIndex].focus();

        } else {
            if (currentIndex === links.length - 1) {
                setActiveLink(currentIndex);
                return;
            }
            event.preventDefault();
            const nextIndex = currentIndex + 1;
            setActiveLink(nextIndex);
            splideInstance.go(nextIndex);
            links[nextIndex].focus();
        }
    });
}

function initFilterKeyboardSupport() {
  document.querySelectorAll('.rolex-filter-body').forEach((container) => {
    container.addEventListener('keydown', (e) => {
      if (
        e.key === 'Enter' &&
        e.target.matches('input[type="checkbox"]')
      ) {
        e.preventDefault();
        e.target.click();
      }
    });
  });
}

// function initConsentLinks() {
//   function updateConsentLinks() {
//     const links = document.querySelectorAll(
//       '.preowned-form-holder div.globo-form-control[data-type="consent"] .checkbox-wrapper .checkbox-label p a'
//     );

//     links.forEach(function (link) {
//       link.target = '_self';
//       link.removeAttribute('rel');
//     });
//   }

//   // Initial run
//   updateConsentLinks();

//   // Watch for Globo dynamically adding the form
//   const observer = new MutationObserver(updateConsentLinks);

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// }


function initPreownedCollectionFilters() {
  const gridContainer = document.querySelector('#ProductGridContainer');
  const filterForm = document.querySelector('#FacetFiltersForm');

  if (!gridContainer || !filterForm) return;

  function reloadCollection(url) {
    gridContainer.classList.add('rolex-loading');

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();

        const doc = parser.parseFromString(html, 'text/html');

        const newGrid = doc.querySelector('#ProductGridContainer');

        if (newGrid) {
          gridContainer.innerHTML = newGrid.innerHTML;
        }

        history.replaceState({}, '', url);

        gridContainer.classList.remove('rolex-loading');
      });
  }

  document.addEventListener('change', function (e) {
    const checkbox = e.target;

    if (checkbox.matches('#FacetFiltersForm input[type="checkbox"]') && checkbox.checked) {
      const group = checkbox.closest('.rolex-filter-group');

      group.querySelectorAll('input[type="checkbox"]').forEach((item) => {
        if (item !== checkbox) {
          item.checked = false;
        }
      });
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.closest('#FacetFiltersForm')) {
      const params = new URLSearchParams(new FormData(filterForm));

      reloadCollection(window.location.pathname + '?' + params.toString());
    }
  });

  document.addEventListener('click', (event) => {
    const sortButton = event.target.closest('[data-sort]');

    if (!sortButton) return;

    const params = new URLSearchParams(window.location.search);

    if (sortButton.dataset.sort) {
      params.set('sort_by', sortButton.dataset.sort);
    } else {
      params.delete('sort_by');
    }

    reloadCollection(window.location.pathname + '?' + params.toString());
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.rolex-load-more');

    if (!button) return;

    const nextUrl = button.dataset.nextUrl;

    if (!nextUrl) return;

    button.disabled = true;

    fetch(nextUrl)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();

        const doc = parser.parseFromString(html, 'text/html');

        const products = doc.querySelectorAll('#product-grid .rolex-preowned-product-grid-inner');

        const grid = document.querySelector('#product-grid');

        products.forEach((product) => {
          grid.appendChild(product);
        });

        const newButton = doc.querySelector('.rolex-load-more');

        if (newButton && newButton.dataset.nextUrl) {
          button.dataset.nextUrl = newButton.dataset.nextUrl;

          button.disabled = false;
        } else {
          button.closest('.rolex-load-more-wrapper')?.remove();
        }
      });
  });
}

document.addEventListener('click', function (e) {
  if (
    e.target.closest('.mobile-filter-toggle') ||
    e.target.closest('.mobile-filter-close') ||
    e.target.closest('.mobile-filter-confirm')
  ) {
    document.querySelector('.rolex-preowned-sidebar')?.classList.toggle('is-open');

    document.body.classList.toggle('rolex-filter-open');
  }
});

document.addEventListener('click', function (e) {
  const sortWrapper = e.target.closest('.rolex-preowned-sort');
  if (sortWrapper) {
    sortWrapper.classList.toggle('active');
  } else {
    document.querySelector('.rolex-preowned-sort')?.classList.remove('active');
  }
  const option = e.target.closest('[data-sort]');
  if (!option) return;
  const current = document.querySelector('.rolex-sort-current');
  current.textContent = option.textContent.trim();
  document.querySelector('.rolex-preowned-sort')?.classList.remove('active');
});